var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgShieldCheckThird(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: 38,
    viewBox: "0 0 36 38",
    width: 36,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd",
    transform: "translate(-7 -5)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 0h48v48h-48z"
  }), /*#__PURE__*/React.createElement("g", {
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }, /*#__PURE__*/React.createElement("path", {
    d: "m20 25 3 3 6-6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m8 21.5340051c0 8.8510862 5.4943968 16.7723065 13.78456 19.8731l.06014.0225c2.0350399.7611764 4.2767429.7604661 6.3113-.002l.04872-.01826c8.2976093-3.1096122 13.79528-11.0409283 13.79528-19.90208v-7.4468c0-1.7497529-1.137262-3.2964286-2.80744-3.8181l-13-4.06045996c-.7765286-.24254019-1.6085514-.24254019-2.38508 0l-13 4.06033996c-1.67019378.5216571-2.80748 2.0683362-2.80748 3.8181z"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgShieldCheckThird);
export default __webpack_public_path__ + "static/media/shield-check-third.61a3f3ccbda00671779740f7e0806a50.svg";
export { ForwardRef as ReactComponent };